module.exports = __webpack_public_path__ + "static/media/story of one A.3ace2668.jpg";